<template>
  <v-card class="left-vertical-card">
    <div class="d-flex flex-column bg-titre mb-2">
      <div class="d-flex justify-space-between">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          Mes contrats non définis
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div
        class="primary--text ml-3 intro"
        label
      >
        {{ typeCultureSelected.nom }}
      </div>
    </div>
    <BaseLoader v-if="loading.contrat" />
    <div
      v-for="(contrat, index) in contratsModifiable"
      :key="index"
      class="card ma-4 pa-4"
    >
      <div class="d-flex">
        <div class="align-self-center mr-2">
          <v-badge
            inline
            color="secondary"
            :content="index + 1"
          />
        </div>
        <div class="d-flex flex-column">
          <div class="intro secondary--text">
            {{ contrat?.libelle }}
          </div>
          <div class="texte texte-gris-fonce">
            {{ contrat?.typeContrat?.libelle }}
          </div>
        </div>
      </div>
      <v-divider class="my-3" />
      <div
        class="d-flex flex-column mt-6 mx-4"
      >
        <AgrialInputNumber
          v-model="contrat.poidsEnTonne"
          label="Poids *"
          return-object
          suffix="t"
          hide-details
        />
      </div>
      <div
        class="d-flex flex-column mt-6 mx-4"
      >
        <AgrialInputNumber
          v-model="contrat.prixPayeEnEuroParTonne"
          label="Prix payé *"
          suffix="€/t"
          hide-details
        />
      </div>
      <div
        v-if="contrat.typePrix && contrat.typePrix.code !== 'PRIX_PAYE' && contrat.typePrix.code !== 'AUCUN'"
        class="d-flex texte texte-gris-fonce flex-column mt-2 mx-4"
      >
        {{ contrat.typePrix.libelle }} : {{ contrat.prixContrat }} €/t
      </div>
      <div
        v-if="contrat.typePrix && contrat.typePrix.code === 'AUCUN'"
        class="d-flex texte texte-gris-fonce flex-column mt-2 mx-4"
      >
        {{ contrat.typePrix.libelle }}
      </div>
      <div
        class="d-flex flex-column mt-4 mx-4"
      >
        <AgrialCheckbox
          v-model="contrat.isPrixProvisoire"
          label="Prix provisoire"
          hide-details
        />
      </div>
    </div>
    <BaseMessage
      v-if="erreur"
      class="mb-3 mx-5"
      color="error"
      :message="erreur"
      text
      type="error"
    />
    <div class="mb-3 ml-5 action texte-gris-fonce">
      * Champs obligatoires
    </div>
    <div class="d-flex justify-space-around mb-5">
      <AgrButton
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :loading="loading"
        class="pa-5"
        @click="saveContrats()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {clone} from '@/utils/clone'
import { AgrButton } from '@agrial/ui'
import AgrialCheckbox from '@/components/form/agrial-checkbox.vue'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'

export default {
  name: 'ListeContratsPrixProvisoireAdherentModal',
  components: {AgrButton, AgrialCheckbox, AgrialInputNumber, BaseLoader, BaseMessage},
  props: {
    typeCultureSelected: {
      type: Object,
      default: null
    },
    contrats: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: false,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis'
      }
    }
  },
  computed: {
    ...mapGetters({
      typesPrix: 'contratVente/typesPrix'
    }),
    contratsModifiable () {
      let result = []
        this.contrats.forEach((contrat) => {
          let contratModifiable = {}
          contratModifiable = clone(contrat)
          contratModifiable.libelle = contrat.libelle
          contratModifiable.typeContrat = contrat.typeContrat 
          contratModifiable.poidsEnTonne = contrat.poidsEnTonne 
          contratModifiable.typePrix = contrat.typePrix 
          contratModifiable.prixPayeEnEuroParTonne = contrat.typePrix.code !== 'PRIX_PAYE' ? null : contrat.prixPayeEnEuroParTonne 
          contratModifiable.prixContrat = contrat.prixPayeEnEuroParTonne
          contratModifiable.isPrixProvisoire = contrat.isPrixProvisoire
          result.push(contratModifiable)
        })
        return result
    }
  },

  created () {
    this.getTypesPrix()
  },

  methods: {
    ...mapActions({
      createOrUpdateContratVente: 'contratVente/createOrUpdateContratVente',
      getTypesPrix: 'contratVente/getTypesPrix'
    }),
    onClose () {
      this.$emit('close')
    },
    saveContrats () {
      this.loading = true
      this.erreur = null
      this.contratsModifiable.forEach((c => {
        let contrat = {}
        contrat.id = c.id
        contrat.numtiers = c.numtiers
        contrat.anneeRecolte = c.anneeRecolte
        contrat.contratAgrial = false
        let culture = c.cultures[0]
        culture.poidsEnTonne = c.poidsEnTonne
        contrat.cultures = [culture]
        contrat.dateCreation = c.dateCreation
        contrat.userCreation = c.userCreation
        contrat.libelle = c.libelle
        contrat.typeContrat = c.typeContrat 
        contrat.poidsEnTonne = c.poidsEnTonne 
        contrat.typePrix = c.prixPayeEnEuroParTonne!= null ? this.typesPrix.find(t => t.code ==='PRIX_PAYE') : c.typePrix
        contrat.prixPayeEnEuroParTonne = c.prixPayeEnEuroParTonne || c.prixContrat
        contrat.isPrixProvisoire = c.isPrixProvisoire != null ? c.isPrixProvisoire: false
        this.createOrUpdateContratVente(contrat)
          .catch(err => {
            this.erreur = err.response.data.message
          })
      }))
      this.$emit('close')
      this.$emit('reload')
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0px !important;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.card {
  border: 1px solid #d7d8d6;
  border-radius: 4px;
}
</style>
